import { default as _91slug_93tmUtWCrUiXMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/_blog2_disabled/[slug].vue?macro=true";
import { default as _91slug_93rD5ORMWVlMMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/[slug].vue?macro=true";
import { default as about_45us7S2S5lTc9HMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/about-us.vue?macro=true";
import { default as aboutvIvhics81HMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/about.vue?macro=true";
import { default as indexSShedG6mMdMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/blog/index.vue?macro=true";
import { default as _91_46_46_46page_93HXlOKasUAiMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/blog/page/[...page].vue?macro=true";
import { default as careerslgoxRgOAitMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/careers.vue?macro=true";
import { default as index3BgeDyicYuMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/category/[category]/index.vue?macro=true";
import { default as _91_46_46_46page_930Ygm62SMdZMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/category/[category]/page/[...page].vue?macro=true";
import { default as _91_46_46_46params_93sB5r7j9UBKMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/connect/sfdc-expert/[...params].vue?macro=true";
import { default as _91_46_46_46params_93m7MyWwA8Q3Meta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/connect/sfdc-partner/[...params].vue?macro=true";
import { default as contactTChVVoDEegMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/contact.vue?macro=true";
import { default as e_45signature_45successfGRnk89DXDMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/demo/e-signature-success.vue?macro=true";
import { default as e_45signaturecuc5zFVneiMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/demo/e-signature.vue?macro=true";
import { default as indexzmpoJTDj2JMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/demo/index.vue?macro=true";
import { default as survey_45successt7hcaUsHcoMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/demo/survey-success.vue?macro=true";
import { default as surveyG5kcyVq8LjMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/demo/survey.vue?macro=true";
import { default as indexmgxABMqby9Meta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/index.vue?macro=true";
import { default as salesforce_45data_45display20rxFtiHDKMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/products/salesforce-data-display.vue?macro=true";
import { default as custom_45salesforce_45developmentcLRLUftgnUMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/custom-salesforce-development.vue?macro=true";
import { default as email_45automationjzUEqiZWrcMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/email-automation.vue?macro=true";
import { default as headless_45salesforceNV8xPMDoLIMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/headless-salesforce.vue?macro=true";
import { default as hire_45salesforce_45developerB2NwxzgOblMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/hire-salesforce-developer.vue?macro=true";
import { default as indexPBDNtTn9UNMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/index.vue?macro=true";
import { default as pdf_45automationFZTBWZWbFLMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/pdf-automation.vue?macro=true";
import { default as react_45vue_45salesforceO9TH6ca3XHMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/react-vue-salesforce.vue?macro=true";
import { default as salesforce_45api_45integration7c7fhwgKLkMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-api-integration.vue?macro=true";
import { default as salesforce_45consultingYF1Y22UDjiMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-consulting.vue?macro=true";
import { default as salesforce_45customer_45portals5HlIx7uaFyMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-customer-portals.vue?macro=true";
import { default as salesforce_45data_45driven_45websites2tR8cjzphJMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-data-driven-websites.vue?macro=true";
import { default as salesforce_45data_45visualizationO5t6krIjisMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-data-visualization.vue?macro=true";
import { default as salesforce_45e_45signqvppwlAn2KMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-e-sign.vue?macro=true";
import { default as salesforce_45event_45registrationkFBs5UYV1mMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-event-registration.vue?macro=true";
import { default as salesforce_45experience_45cloudfbEeTbOeukMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-experience-cloud.vue?macro=true";
import { default as salesforce_45formsO7PXh6Tk7PMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-forms.vue?macro=true";
import { default as salesforce_45implementationIk5AfOELfjMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-implementation.vue?macro=true";
import { default as salesforce_45integrationxM6NrrXg5WMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-integration.vue?macro=true";
import { default as salesforce_45lead_45capture_45websitesMAqyc9epzJMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-lead-capture-websites.vue?macro=true";
import { default as salesforce_45migrationaTWS8Wt8CEMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-migration.vue?macro=true";
import { default as salesforce_45mobile_45sitesgDKuOueqjCMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-mobile-sites.vue?macro=true";
import { default as salesforce_45public_45sitesjmz0tltLRIMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-public-sites.vue?macro=true";
import { default as salesforce_45web_45app_45developmentbz7mNAzwVKMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-web-app-development.vue?macro=true";
import { default as salesforce_45wordpress_45integration_45usaAmWDaQlq3lMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-wordpress-integration-usa.vue?macro=true";
import { default as salesforce_45wordpress_45integrationadvcH0JotSMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-wordpress-integration.vue?macro=true";
import { default as shopify_45salesforce_45integrationgvMt7fxHhSMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/shopify-salesforce-integration.vue?macro=true";
import { default as indexR921dhhXBDMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/index.vue?macro=true";
import { default as pdf_45generation_45guide4nVbdkJUqqMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/pdf-generation-guide.vue?macro=true";
import { default as salesforce_45pdf_45buildertUzdPRlwItMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/salesforce-pdf-builder.vue?macro=true";
import { default as salesforce_45web_45to_45case_45form_45buildergKKNqbuxN7Meta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/salesforce-web-to-case-form-builder.vue?macro=true";
import { default as salesforce_45web_45to_45lead_45form_45builderOKbI1twv6MMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/salesforce-web-to-lead-form-builder.vue?macro=true";
import { default as web_45to_45case_45guideCftZXobVctMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/web-to-case-guide.vue?macro=true";
import { default as web_45to_45lead_45guideIxvTAMM9woMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/web-to-lead-guide.vue?macro=true";
import { default as component_45stubdY2Tlw8WeAMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubdY2Tlw8WeA } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "_blog2_disabled-slug",
    path: "/_blog2_disabled/:slug()",
    meta: _91slug_93tmUtWCrUiXMeta || {},
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/_blog2_disabled/[slug].vue").then(m => m.default || m)
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_93rD5ORMWVlMMeta || {},
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/[slug].vue").then(m => m.default || m)
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/about.vue").then(m => m.default || m)
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "blog-page-page",
    path: "/blog/page/:page(.*)*",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/blog/page/[...page].vue").then(m => m.default || m)
  },
  {
    name: "careers",
    path: "/careers",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/careers.vue").then(m => m.default || m)
  },
  {
    name: "category-category",
    path: "/category/:category()",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/category/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: "category-category-page-page",
    path: "/category/:category()/page/:page(.*)*",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/category/[category]/page/[...page].vue").then(m => m.default || m)
  },
  {
    name: "connect-sfdc-expert-params",
    path: "/connect/sfdc-expert/:params(.*)*",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/connect/sfdc-expert/[...params].vue").then(m => m.default || m)
  },
  {
    name: "connect-sfdc-partner-params",
    path: "/connect/sfdc-partner/:params(.*)*",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/connect/sfdc-partner/[...params].vue").then(m => m.default || m)
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: "demo-e-signature-success",
    path: "/demo/e-signature-success",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/demo/e-signature-success.vue").then(m => m.default || m)
  },
  {
    name: "demo-e-signature",
    path: "/demo/e-signature",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/demo/e-signature.vue").then(m => m.default || m)
  },
  {
    name: "demo",
    path: "/demo",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/demo/index.vue").then(m => m.default || m)
  },
  {
    name: "demo-survey-success",
    path: "/demo/survey-success",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/demo/survey-success.vue").then(m => m.default || m)
  },
  {
    name: "demo-survey",
    path: "/demo/survey",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/demo/survey.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "products-salesforce-data-display",
    path: "/products/salesforce-data-display",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/products/salesforce-data-display.vue").then(m => m.default || m)
  },
  {
    name: "services-custom-salesforce-development",
    path: "/services/custom-salesforce-development",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/custom-salesforce-development.vue").then(m => m.default || m)
  },
  {
    name: "services-email-automation",
    path: "/services/email-automation",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/email-automation.vue").then(m => m.default || m)
  },
  {
    name: "services-headless-salesforce",
    path: "/services/headless-salesforce",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/headless-salesforce.vue").then(m => m.default || m)
  },
  {
    name: "services-hire-salesforce-developer",
    path: "/services/hire-salesforce-developer",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/hire-salesforce-developer.vue").then(m => m.default || m)
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/index.vue").then(m => m.default || m)
  },
  {
    name: "services-pdf-automation",
    path: "/services/pdf-automation",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/pdf-automation.vue").then(m => m.default || m)
  },
  {
    name: "services-react-vue-salesforce",
    path: "/services/react-vue-salesforce",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/react-vue-salesforce.vue").then(m => m.default || m)
  },
  {
    name: "services-salesforce-api-integration",
    path: "/services/salesforce-api-integration",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-api-integration.vue").then(m => m.default || m)
  },
  {
    name: "services-salesforce-consulting",
    path: "/services/salesforce-consulting",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-consulting.vue").then(m => m.default || m)
  },
  {
    name: "services-salesforce-customer-portals",
    path: "/services/salesforce-customer-portals",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-customer-portals.vue").then(m => m.default || m)
  },
  {
    name: "services-salesforce-data-driven-websites",
    path: "/services/salesforce-data-driven-websites",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-data-driven-websites.vue").then(m => m.default || m)
  },
  {
    name: "services-salesforce-data-visualization",
    path: "/services/salesforce-data-visualization",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-data-visualization.vue").then(m => m.default || m)
  },
  {
    name: "services-salesforce-e-sign",
    path: "/services/salesforce-e-sign",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-e-sign.vue").then(m => m.default || m)
  },
  {
    name: "services-salesforce-event-registration",
    path: "/services/salesforce-event-registration",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-event-registration.vue").then(m => m.default || m)
  },
  {
    name: "services-salesforce-experience-cloud",
    path: "/services/salesforce-experience-cloud",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-experience-cloud.vue").then(m => m.default || m)
  },
  {
    name: "services-salesforce-forms",
    path: "/services/salesforce-forms",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-forms.vue").then(m => m.default || m)
  },
  {
    name: "services-salesforce-implementation",
    path: "/services/salesforce-implementation",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-implementation.vue").then(m => m.default || m)
  },
  {
    name: "services-salesforce-integration",
    path: "/services/salesforce-integration",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-integration.vue").then(m => m.default || m)
  },
  {
    name: "services-salesforce-lead-capture-websites",
    path: "/services/salesforce-lead-capture-websites",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-lead-capture-websites.vue").then(m => m.default || m)
  },
  {
    name: "services-salesforce-migration",
    path: "/services/salesforce-migration",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-migration.vue").then(m => m.default || m)
  },
  {
    name: "services-salesforce-mobile-sites",
    path: "/services/salesforce-mobile-sites",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-mobile-sites.vue").then(m => m.default || m)
  },
  {
    name: "services-salesforce-public-sites",
    path: "/services/salesforce-public-sites",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-public-sites.vue").then(m => m.default || m)
  },
  {
    name: "services-salesforce-web-app-development",
    path: "/services/salesforce-web-app-development",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-web-app-development.vue").then(m => m.default || m)
  },
  {
    name: "services-salesforce-wordpress-integration-usa",
    path: "/services/salesforce-wordpress-integration-usa",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-wordpress-integration-usa.vue").then(m => m.default || m)
  },
  {
    name: "services-salesforce-wordpress-integration",
    path: "/services/salesforce-wordpress-integration",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-wordpress-integration.vue").then(m => m.default || m)
  },
  {
    name: "services-shopify-salesforce-integration",
    path: "/services/shopify-salesforce-integration",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/shopify-salesforce-integration.vue").then(m => m.default || m)
  },
  {
    name: "tools",
    path: "/tools",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/index.vue").then(m => m.default || m)
  },
  {
    name: "tools-pdf-generation-guide",
    path: "/tools/pdf-generation-guide",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/pdf-generation-guide.vue").then(m => m.default || m)
  },
  {
    name: "tools-salesforce-pdf-builder",
    path: "/tools/salesforce-pdf-builder",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/salesforce-pdf-builder.vue").then(m => m.default || m)
  },
  {
    name: "tools-salesforce-web-to-case-form-builder",
    path: "/tools/salesforce-web-to-case-form-builder",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/salesforce-web-to-case-form-builder.vue").then(m => m.default || m)
  },
  {
    name: "tools-salesforce-web-to-lead-form-builder",
    path: "/tools/salesforce-web-to-lead-form-builder",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/salesforce-web-to-lead-form-builder.vue").then(m => m.default || m)
  },
  {
    name: "tools-web-to-case-guide",
    path: "/tools/web-to-case-guide",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/web-to-case-guide.vue").then(m => m.default || m)
  },
  {
    name: "tools-web-to-lead-guide",
    path: "/tools/web-to-lead-guide",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/web-to-lead-guide.vue").then(m => m.default || m)
  },
  {
    name: component_45stubdY2Tlw8WeAMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubdY2Tlw8WeA
  }
]